<template>
  <div
    class="search-result"
    v-loading="loading"
    element-loading-text="加载中"
    element-loading-spinner="el-icon-loading"
  >
    <!-- <result-size :resultNum="resultNum" :curPage="curPage"></result-size> -->
    <!-- <sort-pattern :detailIcon="detailIcon" :listIcon="listIcon" :modelType="mosdelType"></sort-pattern> -->
    <div class="result-detail">
      <div class="Book" v-for="(item, index) in bookList" :key="index">
        <div class="ShowBook">
          <div class="book-data">
            <div>
              <img
                class="book-cover"
                data-warden-title="显示文章内容"
                :data-warden-info="item.bookName"
                :data-warden-bookId="item.id"
                @click="jumpBookDetail(item)"
                :src="item.bookCover"
              />
            </div>
            <div class="book-info-right">
              <div class="book-info">
                <div
                  class="book-name"
                  data-warden-title="显示文章内容"
                  :data-warden-info="item.bookName"
                  :data-warden-bookId="item.id"
                  @click="jumpBookDetail(item)"
                >
                  <span v-html="item.bookName"></span>
                </div>
                <img
                  v-if="item.star === 1"
                  src="../assets/images/icons/star1.png"
                  class="star-icon"
                  @click="handleCilckCollect(item)"
                  title="取消收藏"
                />
                <img
                  v-else-if="item.star === 2"
                  src="../assets/images/icons/star2.png"
                  class="star-icon"
                  @click="handleCilckCollect(item)"
                  title="收藏书籍"
                />
              </div>
              <div class="book-intro">
                <img class="book-icon" src="../assets/images/icons/witer.png" />
                <span class="left">著者</span>
                :
                <span v-html="item.authorDetail"></span>
              </div>
              <div class="book-intro">
                <img
                  class="book-icon"
                  src="../assets/images/SearchPage/folder.png"
                />
                <span class="left">分类</span>
                :
                <span v-html="item.classification"></span>
              </div>
              <div class="book-intro">
                <img class="book-icon" src="../assets/images/icons/year.png" />
                <span>成书年</span>
                :
                <span v-html="item.completionTime"></span>
              </div>
              <div class="book-intro">
                <img
                  class="book-icon"
                  src="../assets/images/icons/version.png"
                />
                <span class="left">版本</span>
                :
                <span v-html="item.edition"></span>
              </div>
            </div>
          </div>
          <div class="position">
            <img
              class="position-icon"
              src="../assets/images/icons/position.png"
            />
            <span>馆藏地：</span>
            <span v-html="item.library"></span>
          </div>
        </div>
        <div class="ShowMarch" v-if="item.matchPagesNum">
          <div class="march-title">
            <span style="font-size:16px;width: 96px;">【匹配条目】</span>
            <span style="margin-left:70px;">共</span>
            <span style="color:#9E5C1D">{{ item.matchPagesNum }}</span>
            <span>条记录，总</span>
            <span style="color:#9E5C1D">{{ item.pageAll }}</span>
            <span>页，第</span>
            <span style="color:#9E5C1D">{{ item.pageNow }}</span>
            <span>页</span>
            <a
              @click="handleInfoPagePrev(item)"
              class="page-change"
              style="margin-left:10px;"
              >上一页</a
            >
            <a
              @click="handleInfoPageNext(item)"
              class="page-change"
              style="margin-left:10px;"
              >下一页</a
            >
          </div>
          <div class="info-list">
            <div v-for="(Ite, i) in item.curPage" :key="i">
              <span>({{ Ite.pageName }})</span>
              <span
                v-html="Ite.text"
                data-warden-title="显示文章内容"
                :data-warden-info="Ite.bookName"
                :data-warden-bookId="item.bookId"
                class="links"
                @click="jumpBookPageDetail(Ite)"
              ></span>
            </div>
          </div>
        </div>
        <div v-else class="no-result">
          暂无匹配结果
        </div>
      </div>
      <!-- 暂无结果 -->
      <div v-if="bookList.length === 0" class="search-no-result">
        暂无结果
      </div>
    </div>
    <my-dialog
      :title="'提示'"
      :icon="require('@/assets/images/userPage/user.png')"
      ref="messageDialog"
      class="message-dialog"
      @confirm="clearHistory"
    >
      确认取消该收藏？
    </my-dialog>
    <!-- <page-bar :pageNum="pageNum" :curPage="curPage"></page-bar> -->
    <RetrieveDialogCollect
      v-if="openCollect"
      :openCollect="openCollect"
      :bookId="bookId"
      @closeCollect="closeCollect"
      @collectSuccess="collectSuccess"
    ></RetrieveDialogCollect>
  </div>
</template>

<script>
import PageBar from './PageBar.vue'
import ResultSize from './ResultSize.vue'
import SortPattern from './SortPattern .vue'
import RetrieveDialogCollect from './RetrieveDialogCollect.vue'
import MyDialog from './MyDialog.vue'
import { Message } from 'element-ui'
import router from '@/router'
export default {
  components: {
    PageBar,
    ResultSize,
    SortPattern,
    RetrieveDialogCollect,
    MyDialog
  },
  name: 'SearchResultDetail',
  props: {},
  data () {
    return {
      pageNum: 1,
      curPage: 1,
      modelType: 1,
      keyWord: '岭南',
      bookList: [],
      infoPageSize: 5,
      loading: true,
      openCollect: false,
      bookId: 0,
      pageSize: 10,
      collects: []
    }
  },
  mounted () {
    this.$bus.$on('updateSearchResult', data => {
      console.log(data)
      //   console.log(data.data1)
      //   console.log(data.data2)
      //   this.loading = true
      this.pageNum = Math.ceil((data.data1.length + 0.0) / this.pageSize)
      this.curPage = 1
      for (let i = 0; i < data.data1.length; i++) {
        let url = '/retrieve/page/getImage'
        let params = {
          bookId: data.data1[i].id,
          page: 1
        }
        let image = require('../assets/images/bookCover/u553.jpg')
        data.data1[i].bookCover = image
        this.$http({
          method: 'get',
          url: url,
          params: params,
          responseType: 'blob'
        }).then(res => {
          const binaryData = []
          binaryData.push(res.data)
          const url = window.URL.createObjectURL(
            new Blob(binaryData, { type: 'image/jpg' })
          )
          data.data1[i].bookCover = url
        })
        if (String(data.data2[i].isInStoreBook) === 'true') {
          data.data1[i].star = 1
        } else {
          data.data1[i].star = 2
        }

        // 处理匹配条目
        // 匹配的页
        data.data1[i].matchInfo = data.data1[i].matchPages
        for (let j = 0; j < data.data1[i].matchInfo.length; j++) {
          data.data1[i].matchInfo[j].bookId = data.data1[i].id
        }
        console.log(data.data1[i].matchPageKeyword)
        // 匹配的关键词
        for (let j = 0; j < data.data1[i].matchPageKeyword.length; j++) {
          data.data1[i].matchInfo.push({
            page: data.data1[i].matchPageKeyword[j].page,
            pageName: data.data1[i].matchPageKeyword[j].pageName,
            text: data.data1[i].matchPageKeyword[j].keyword,
            bookId: data.data1[i].id
          })
        }

        data.data1[i].matchPagesNum = data.data1[i].matchInfo.length
        data.data1[i].pageNow = 1
        data.data1[i].pageAll = Math.ceil(
          data.data1[i].matchPagesNum / this.infoPageSize
        )
        data.data1[i].curPage = data.data1[i].matchInfo.slice(
          0,
          this.infoPageSize
        )
        data.data1[i].bookId = data.data1[i].id
      }
      this.bookList = data.data1
      this.loading = false
    })
    this.$bus.$on('collectSuccess', data => {
      let id1 = this.bookList.findIndex(item => item.bookId === data)
      this.bookList[id1].star = 1
    })
  },
  beforeDestroy () {
    this.$bus.$off('updateSearchResult')
    this.$bus.$off('collectSuccess')
  },
  methods: {
    jumpBookPageDetail (book) {
      let pathInfo = '/bookDetail'
      if (this.$route.params.url) {
        pathInfo = '/' + this.$route.params.url + pathInfo
      }
      let routeUrl = this.$router.resolve({
        path: pathInfo,
        query: {
          book: book.bookId,
          page: book.page
        }
      })
      window.open(routeUrl.href, '_blank')
    },
    jumpBookDetail (book) {
      let pathInfo = '/bookDetail'
      if (this.$route.params.url) {
        pathInfo = '/' + this.$route.params.url + pathInfo
      }
      let routeUrl = this.$router.resolve({
        path: pathInfo,
        query: {
          book: book.id
        }
      })
      window.open(routeUrl.href, '_blank')
    },
    handleInfoPagePrev (item) {
      item.pageNow--
      if (item.pageNow < 1) item.pageNow = 1
      item.curPage = item.matchInfo.slice(
        item.pageNow * this.infoPageSize - this.infoPageSize,
        item.pageNow * this.infoPageSize
      )
    },
    handleInfoPageNext (item) {
      item.pageNow++
      if (item.pageNow > item.pageAll) item.pageNow = item.pageAll

      if (item.pageNow * this.infoPageSize > item.matchInfo.length) {
        item.curPage = item.matchInfo.slice(
          item.pageNow * this.infoPageSize - this.infoPageSize,
          item.matchInfo.length
        )
      } else {
        item.curPage = item.matchInfo.slice(
          item.pageNow * this.infoPageSize - this.infoPageSize,
          item.pageNow * this.infoPageSize
        )
      }
    },
    closeCollect () {
      this.openCollect = false
    },
    handleCilckCollect (item) {
      if (String(localStorage.getItem('isLogined')) === 'true') {
        if (item.star === 2) {
          this.openCollect = true
          this.bookId = item.bookId
          console.log(this.$router)
        } else {
          this.$refs.messageDialog.open(() => {
            console.log(item)
            let userId = localStorage.getItem('userId')
            let url =
              'retrieve/storeBook/deleteBookInStore?userId=' +
              userId +
              '&bookId=' +
              item.bookId
            this.$http.delete(url).then(res => {
              // console.log('取消收藏成功')
              Message({
                type: 'success',
                message: '取消收藏成功!'
              })
              item.star = 2
            })
          })
        }
      } else {
        Message({
          type: 'error',
          message: '用户需要登录才能完成操作!'
        })
      }
    },
    clearHistory () {
      this.$refs.messageDialog.close()
    }
  }
}
</script>

<style scoped>
.search-result {
  width: 933px;
  height: 650px;
  /* margin-left: 18px; */
  background: #ffffff;
}

.page-bar {
  display: flex;
  justify-content: center;
  align-items: center;
}

.result-detail {
  width: 910px;
  height: 660px;
  /* margin: auto; */
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 12px;
}

.Book {
  display: grid;
  grid-template-columns: 1fr 3fr;
  width: 900px;
  height: 210px;
  background: rgba(244, 242, 241, 0.26);
  border: 1px solid #f4f2f1;
  margin-bottom: 10px;
}

.ShowBook {
  width: 340px;
  height: 210px;
  background: rgba(248, 240, 232, 0.49);
  border: 1px solid #f4f2f1;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.book-data {
  display: grid;
  grid-template-columns: 0.5fr 1fr;
}

.book-info-right {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-start;
  margin-right: 10px;
  margin-left: 20px;
}

.book-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
}

.book .ShowMarch {
  width: 578px;
  height: 210px;
  margin-left: 340px;
}

.book-cover {
  cursor: pointer;
  width: 104px;
  height: 146px;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
  margin: 0px 0px 0px 11px;
  transition: all 0.3s;
}

.book-cover:hover {
  /* opacity: 0.7; */
  transform: scale(1.05);
}

.book-name {
  font-size: 18px;
  font-weight: bold;
  color: #9e5c1d;
  cursor: pointer;
}

.book-name:hover {
  color: #9e5c1d;
  opacity: 0.7;
}

.star-icon {
  /* margin-left: 68px; */
  /* width: 29px; */
  /* height: 25px; */
  position: relative;
  top: 2px;
}

.star-icon:hover {
  opacity: 0.7;
}

.book-intro {
  /* float: left; */
  /* margin-left: 17px; */
  font-size: 14px;
  text-align: left;
}

.book-icon {
  width: 18px;
  height: 18px;
  vertical-align: text-top;
}

.left {
  width: 45px;
  display: inline-block;
  text-align-last: justify;
}

.position {
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #a29c95;
  line-height: 0px;
}

.position-icon {
  width: 18px;
  height: 18px;
}

.march-title {
  float: left;
  margin-left: 8px;
  font-size: 14px;
  margin-top: 12px;
}

.march-title a {
  width: 42px;
  height: 14px;
  border-bottom: 1px solid #9e5c1d;
}

.info-list {
  width: 559px;
  height: 135px;
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #634c37;
  line-height: 30px;
  text-align-last: left;
  margin-left: 12px;
  position: relative;
  top: 10px;
  display: inline-block;
}

ul,
li {
  margin: 0px;
  padding: 0px;
  display: flex;
}

li {
  list-style: none;
}
/* 滚动条 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.06);
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: rgba(158, 92, 29, 0.2);
}

.links {
  border-bottom: 1px solid rgba(99, 76, 55, 1);
  cursor: pointer;
}

.page-change {
  cursor: pointer;
}

.search-result >>> .el-loading-spinner i {
  color: #9e5c1d;
  font-size: 30px;
}

.search-result >>> .el-loading-spinner p {
  color: #634c37;
  font-size: 18px;
}
.message-dialog >>> .el-dialog {
  width: 380px;
  height: 265px;
}

.message-dialog >>> .el-dialog__body {
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #634c37;
}

.search-no-result {
  width: 933px;
  height: 650px;
  /* margin-left: 18px; */
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/SearchResultDetail.vue